import {mixins} from "../app/mixin";

mixins.push({
    el: '.services',
    data() {
        return {
            activeTab: 1,
            activeItem: 0,
            image: 'carbon-footprint',
            activeMenu: window.activeMenu,
        }
    },
    methods: {
        setActiveTab(index, image, name) {
            this.activeTab = index;
            this.activeItem = 0;
            this.image = image;
            this.activeMenu = name;
        },
        setActiveItem(index, image) {
            this.activeItem = index;
            this.image = image;
        },
        getImagePath() {
            return 'build/images/vectors/' + this.image + '-purple.svg';
        }
    }
});